import * as React from 'react';
import Link from 'next/link';

interface IArticleCardProps {
  children: React.ReactNode;
  url: string;
  isTargetBlank?: boolean;
  UNSAFE_className?: string;
}

const ArticleCard: React.FC<IArticleCardProps> = ({
  children,
  url,
  isTargetBlank = false,
  UNSAFE_className,
}) => {
  return (
    <article className={`tw-w-[210px] ${UNSAFE_className}`}>
      <Link href={url} target={isTargetBlank ? '_blank' : '_self'}>
        {children}
      </Link>
    </article>
  );
};

export default ArticleCard;
